import * as React from "react";

import { Button, Grid, Modal, TextInput, Title } from "@mantine/core";
import {
  addNodeViaPort,
  addViaEdge,
  BaseEdgeDataType,
  BaseNodeDataType,
  createNode,
  workflowActionTypes,
  workflowStateType,
} from "../WorkflowUtils";
import { IDispatchAction } from "src/types";
import { UAction, UNodeType, UseCaseType } from "@supportinitiative/common";
import { UseCaseCVMContext } from "../../UseCaseCVMContext";
import { showNotification } from "@mantine/notifications";
import { getId, getIsStringMatch } from "../../../utilities";
import { UseFieldArrayReturn } from "react-hook-form";

export default function AddViaPort({
  name,
  port,
  workflowDispatch,
  nodes,
  edges,
  actions,
  options,
  fromOrchestrator,
  reconsArray,
}: {
  name: string;
  port: {
    from: string;
    to?: string | null;
  };
  workflowDispatch: React.Dispatch<
    IDispatchAction<workflowActionTypes, workflowStateType>
  >;
  nodes: BaseNodeDataType[];
  edges: BaseEdgeDataType[];
  actions: UAction[];
  options: { label: string; name: string; icon: React.ReactNode }[];
  fromOrchestrator?: boolean;
  reconsArray?: UseFieldArrayReturn<UseCaseType, "definition.recons", "key">;
}) {
  const { state: useCaseFormState } = React.useContext(UseCaseCVMContext);

  let [filteredOptions, setFilteredOptions] = React.useState(options);

  return (
    <Modal
      centered
      size={"xl"}
      opened={true}
      onClose={() => {
        workflowDispatch({
          type: "RESET",
          value: {
            action: null,
            via: null,
          },
        });
      }}
      title={<Title order={3}>Add</Title>}
    >
      <Grid align="stretch" gutter={"xs"} mb="xs">
        <Grid.Col span={12}>
          <TextInput
            placeholder="Filter"
            onChange={(event) => {
              if (event.target.value) {
                let values = options.filter(
                  getIsStringMatch(event.target.value)
                );
                setFilteredOptions(values);
              } else {
                setFilteredOptions(options);
              }
            }}
          />
        </Grid.Col>
      </Grid>

      <Grid align="center" gutter={"xs"} mt="lg" mb="xs">
        {filteredOptions.map((option) => {
          return (
            <Grid.Col span={3} key={option.name}>
              <Button
                leftSection={option.icon}
                fullWidth
                variant="default"
                onClick={() => {
                  const newNode = createNode(
                    getId(),
                    option.name as UNodeType,
                    option.name
                  );
                  if (port) {
                    const newWorkflow = addNodeViaPort(
                      newNode,
                      port,
                      nodes,
                      edges,
                      actions
                    );
                    // console.log("newWorkflow", newWorkflow);
                    if (fromOrchestrator) {
                      if (
                        newNode.data?.type.toUpperCase() === "MONITORING" ||
                        newNode.data?.type.toUpperCase() === "RECONCILIATION"
                      ) {
                        const action = newWorkflow.actions.find(
                          (act) => act.id === newNode.id
                        );

                        if (action) {
                          // call reconsArray.append only for orchestrator
                          // @ts-ignore
                          reconsArray ? reconsArray.append(action) : null;
                          useCaseFormState.setValue(name, newWorkflow);
                        } else {
                          showNotification({
                            id: "error",
                            title: "New node",
                            message:
                              "Unable to add new reconciliation/monitoring flow",
                            color: "red",
                          });
                        }
                      } else {
                        useCaseFormState.setValue(name, newWorkflow);
                      }
                    } else {
                      // console.log(name, newWorkflow);
                      useCaseFormState.setValue(name, newWorkflow);
                    }
                    workflowDispatch({
                      type: "RESET",
                      value: {
                        action: null,
                        via: null,
                      },
                    });
                  }
                }}
              >
                {option.label}
              </Button>
            </Grid.Col>
          );
        })}
      </Grid>
    </Modal>
  );
}
